<template>
    <div>
        <PageBanner :pageTitle="$t('sidebar_inonlays_title_two')" />

        <InOnLaysHurt/>
    </div>
</template>

<script>
import InOnLaysHurt from '../blog-details/InOnLaysHurt.vue'
import PageBanner from '../Common/PageBanner'

export default {
    components: {
       PageBanner,
        InOnLaysHurt ,
    }
}
</script>